// skipcq: JS-W1028
import { useCallback, useContext, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { UserContext } from '../../context/UserContext';
import { trackBrewhouseNavClick } from '../../utils/brewhousePortalAnalytics';
import { sidebarDrawerContentSx } from '../../utils/vintageSurfaces';
import { getVisibleBrewhousePortalNavItems } from './brewhousePortalNavConfig';

function pathnameMatchesNavPath(pathname, navPath) {
  if (typeof pathname !== 'string' || typeof navPath !== 'string') {
    return false;
  }
  return pathname === navPath || pathname.startsWith(`${navPath}/`);
}

function BrewhousePortalNavItem({ navItem, isSelected, onNavClick }) {
  const handleClick = useCallback(
    function handleClick() {
      onNavClick(navItem.analyticsItem);
    },
    [navItem.analyticsItem, onNavClick],
  );

  return (
    <ListItem disablePadding>
      <ListItemButton
        component={Link}
        to={navItem.path}
        selected={isSelected}
        onClick={handleClick}
      >
        <ListItemIcon>{navItem.icon}</ListItemIcon>
        <ListItemText primary={navItem.text} />
      </ListItemButton>
    </ListItem>
  );
}

function BrewhousePortalSidebar({ onNavigate }) {
  const user = useContext(UserContext);
  const location = useLocation();
  const visibleNavItems = useMemo(
    function resolveVisibleNavItems() {
      return getVisibleBrewhousePortalNavItems(user.isBreweryAdmin === true);
    },
    [user.isBreweryAdmin],
  );

  const handleNavClick = useCallback(
    function handleNavClick(analyticsItem) {
      trackBrewhouseNavClick(analyticsItem);
      if (typeof onNavigate === 'function') {
        onNavigate();
      }
    },
    [onNavigate],
  );

  return (
    <Box sx={sidebarDrawerContentSx()}>
      <Toolbar variant="dense" sx={{ minHeight: 48 }}>
        <Typography
          variant="h6"
          noWrap
          component="div"
          sx={{
            fontFamily: '"Henny Penny", cursive',
            fontWeight: 400,
            color: '#F9DA85',
          }}
        >
          I&apos;d Tap That
        </Typography>
      </Toolbar>
      <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.14)' }} />
      <List>
        {visibleNavItems.map((navItem) => (
          <BrewhousePortalNavItem
            key={navItem.path}
            navItem={navItem}
            isSelected={pathnameMatchesNavPath(location.pathname, navItem.path)}
            onNavClick={handleNavClick}
          />
        ))}
      </List>
    </Box>
  );
}

export default BrewhousePortalSidebar;
